import { ReactElement } from 'react';
import { ClientBadgeContainer } from './styles';

export function ClientBadge({
  clientName,
}: Readonly<{ clientName: string}>): ReactElement {
  return (
    <ClientBadgeContainer>
      <span style={{ marginTop: 0 }}>{clientName}</span>
    </ClientBadgeContainer>
  );
}
